var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      title: _vm.$t("保司审核"),
      okText: _vm.$t("审核"),
      cancelText: _vm.$t("取消"),
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      },
      ok: _vm.handleSure
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 16
      },
      model: _vm.dataFrom,
      rules: _vm.dataRule
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("审核结果"),
      prop: "status"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("审核结果")
    },
    on: {
      change: _vm.statusChange
    },
    model: {
      value: _vm.dataFrom.status,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "status", $$v);
      },
      expression: "dataFrom.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 5
    }
  }, [_vm._v(_vm._s(_vm.$t("资料需要补充或修改")))]), _c("a-select-option", {
    attrs: {
      value: 3
    }
  }, [_vm._v(_vm._s(_vm.$t("通过")))]), _c("a-select-option", {
    attrs: {
      value: 4
    }
  }, [_vm._v(_vm._s(_vm.$t("拒绝赔付")))])], 1)], 1), _vm.dataFrom.status == 4 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("拒绝赔付原因"),
      prop: "content"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("拒绝赔付原因")
    },
    model: {
      value: _vm.dataFrom.content,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "content", $$v);
      },
      expression: "dataFrom.content"
    }
  })], 1) : _vm._e(), _vm.dataFrom.status == 3 ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否需要物理件回寄"),
      prop: "isMailing"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.isMailing,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "isMailing", $$v);
      },
      expression: "dataFrom.isMailing"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("否")))]), _c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("是")))])], 1)], 1) : _vm._e(), _vm.dataFrom.status ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注")
    },
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };